/*
 *
 * PasswordRecovery reducer
 *
 */

import { fromJS } from "immutable"
import {
  RECOVER_WATCHER,
  RECOVER_SUCCESS,
  RECOVER_FAILED,
  RESET_RECOVER,
} from "./constants"

export const initialState = fromJS({
  error: false,
  errorMessage: "",
  isLoading: false,
  success: false,
  email: "",
})

function passwordRecoveryReducer(state = initialState, action) {
  switch (action.type) {
    case RECOVER_WATCHER:
      return state
        .set("isLoading", true)
        .set("email", action.payload)
        .set("error", false)
        .set("success", false)
        .set("errorMessage", "")
    case RECOVER_SUCCESS:
      return state
        .set("isLoading", false)
        .set("success", true)
        .set("errorMessage", "")
    case RECOVER_FAILED:
      return state
        .set("isLoading", false)
        .set("error", true)
        .set("email", "")
    case RESET_RECOVER:
      return state
        .set("isLoading", false)
        .set("error", false)
        .set("email", "")
        .set("errorMessage", "")
        .set("success", false)
    default:
      return state
  }
}

export default passwordRecoveryReducer
